import Vue from "vue";
import Vuex from "vuex";
import home from "./modules/home";
import capture from "./modules/capture";
import topography from "./modules/topography";
import dryeye from "./modules/dryeye";
import getters from "./getters";
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    home,
    capture,
    topography,
    dryeye
  },
  getters
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js